import { z } from "zod";
const answer = z.string().max(4_000);
export const promptFormSchema = z
    .object({
    agentGoal: answer,
    companyContext: answer,
    customerInformation: answer,
    conversationFlow: answer,
    permissionsAndRestrictions: answer,
    handoffConditions: answer,
    communicationStyle: answer,
    additionalComments: answer.optional(),
    role: answer.optional(),
    uncertaintyHandling: answer.optional(),
    objectionHandling: answer.optional(),
    responseExamples: answer.optional(),
})
    .strict()
    .refine((value) => Object.values(value).reduce((n, s) => n + (s?.length ?? 0), 0) <= 16_000, "Questionnaire is too large");
export const systemPromptSchema = z
    .string()
    .max(10_000)
    .refine((v) => v.trim().length > 0, "Prompt must not be empty");
export const generationMetadataSchema = z
    .object({
    promptRevisionIds: z.array(z.string().min(1).max(255)).max(20),
    provider: z.string().min(1).max(255),
    model: z.string().min(1).max(1000),
    generatedAt: z.string().datetime(),
    repairAttempted: z.boolean(),
})
    .strict();
export const remarksShape = {
    warnings: z.array(z.string().min(1).max(1_000)).max(20),
    missingInformation: z.array(z.string().min(1).max(1_000)).max(20),
};
export const legacyResultSchema = z
    .object({ prompt: systemPromptSchema, ...remarksShape })
    .strict();
export const generatedResultSchema = legacyResultSchema
    .extend({ escalationPrompt: systemPromptSchema.nullable() })
    .strict();
export const generationCandidateSchema = generatedResultSchema
    .extend({
    inputHash: z.string().regex(/^[a-f0-9]{64}$/),
    generationMetadata: generationMetadataSchema,
})
    .strict();
export const escalationInputSchema = z
    .object({ systemPrompt: systemPromptSchema, handoffConditions: answer })
    .strict();
export const escalationResultSchema = z
    .object({ escalationPrompt: systemPromptSchema, ...remarksShape })
    .strict();
export const escalationCandidateSchema = escalationResultSchema
    .extend({
    inputHash: z.string().regex(/^[a-f0-9]{64}$/),
    generationMetadata: generationMetadataSchema,
})
    .strict();
export const generationSnapshotSchema = z
    .object({
    schemaVersion: z.literal(1),
    input: promptFormSchema,
    result: generationCandidateSchema,
})
    .strict()
    .refine((value) => new TextEncoder().encode(JSON.stringify(value)).byteLength <= 64_000, "Snapshot exceeds 64000 UTF-8 bytes");
export const promptFieldsShape = {
    promptMode: z.enum(["FORM", "MANUAL"]),
    promptForm: promptFormSchema.nullable(),
    generatedPrompt: z.string().max(10_000).nullable(),
    generationSnapshot: generationSnapshotSchema.nullable(),
    handoffConditions: answer.nullable(),
    escalationPrompt: z.string().max(10_000).nullable(),
};
export const promptFieldsSchema = z
    .object({ ...promptFieldsShape, promptVersion: z.number().int().positive() })
    .strict();
export const promptInputSchema = z.object(promptFieldsShape).partial().strict();
export const promptInputShape = promptInputSchema.shape;
//# sourceMappingURL=prompt-schema.js.map